import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const Alert = ({ type, message, size }) => {
  const getIcon = (type) => {
    switch (type) {
      default:
        return (
          <GetIcon
            name="InfoCircle"
            size={size === "xs" ? "xs" : "sm"}
            type="solid"
            color="red"
          />
        );
    }
  };

  return (
    <S.Alert type={type} size={size}>
      <S.AlertIcon>{getIcon(type)}</S.AlertIcon>
      <S.AlertText>{message}</S.AlertText>
    </S.Alert>
  );
};

export default Alert;
